import TitleBlock from '../arrows/TitleBlock'
import Banner from '../banner/Banner'
import Product from '../product/Product'
import { getColorFromRecipeTags } from '@/functions/common/helper'
import { BannerTypeEnum } from '@/constants/constants'
import { Fragment } from 'react'

const Category = ({
    wareCategory,
    titleVisible = true,
    numberOfLines,
    rowDisplay,
    color,
    banner,
    isPromoCategory,
    promoTag,
    extraAction = null
}) => {
    function renderProducts(rowDisplay) {
        return (
            <>
                {wareCategory.recipes.map(product => {
                    if (!color) color = getColorFromRecipeTags(product)
                    return (
                        <Fragment key={product.id}>
                            <Product
                                productData={product}
                                rowDisplay={rowDisplay}
                                color={color}
                                extraAction={extraAction}
                                promoTag={promoTag}
                                wareCategoryId={wareCategory.id}
                            />
                        </Fragment>
                    )
                })}
            </>
        )
    }

    return (
        <>
            {rowDisplay ? (
                <div className={`mx-2 xs:mx-5`}>
                    {titleVisible && (
                        <div
                            className={
                                'text-left fk-screamer-title leading-none tracking-0-03em uppercase mt-7 mb-3 md:mt-14 md:mb-6 '
                            }
                        >
                            {wareCategory.nameLabel}
                        </div>
                    )}
                    <div className={`gap-2 grid grid-cols-1 mt-4 lg:gap-5 xl:gap-16 2xl:gap-24`}>
                        {renderProducts(true)}
                    </div>
                </div>
            ) : (
                <div
                    className={`${isPromoCategory ? ' pb-16 md:pb-24' : 'mb-8 md:mb-12'} text-center`}
                    id={wareCategory.id}
                >
                    {titleVisible && (
                        <div className={`${isPromoCategory ? 'mb-8 md:mb-12' : 'mb-3 md:mb-12'}`}>
                            <TitleBlock title={wareCategory.nameLabel} numberOfLines={numberOfLines} color={color} />
                        </div>
                    )}
                    <div className={`productListWrapper`}>
                        {renderProducts(false)}
                        {banner && <Banner bannerData={banner} bannerType={BannerTypeEnum.BRANCH_CATEGORY} />}
                    </div>
                </div>
            )}
        </>
    )
}
export default Category
